import {
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  NativeSelect,
  Select,
  ListItemButton,
} from "@mui/material";
import { border, height, width } from "@mui/system";
import Button from "@restart/ui/esm/Button";
import Popover from "@mui/material/Popover";
import Typography from "@mui/material/Typography";
import { List, ListItem, ListItemText } from "@material-ui/core";
import {
  bindTrigger,
  bindPopover,
  usePopupState,
} from "material-ui-popup-state/hooks";
import { GeneralDateRangePicker } from "../../../Components/GeneralComponents/GeneralDateRangePicker";
import moment from "moment";
import { useState } from "react";
import { Link, useRouteMatch } from "react-router-dom";
import "../ReportsHeader.css";
import MaterialSelect from "../../../Components/SelectDropdown/MaterialSelect";
import ExportTable from "../../../Components/Export/ExportTable";
import exportFromJSON from "export-from-json";
import { GeneralDateRangePickerForReport } from "../../../Components/GeneralComponents/GeneralDateRangePickerForReport";
const fileName = "download";
const exportType = exportFromJSON.types.csv;

export const ShareTransferHeader = (props) => {
  const {
    setTabValue,
    tableData,
    tabValue,
    finalData,
    selectValue,
    setSelectValue,
    setData,
    tableRef,
  } = props;
  const [filterDate, setFilterDate] = useState({});

  const handleTabValue = (e) => {
    setTabValue(e.target.value);
    // console.log(e.target.value);
  };
  // console.log(tabValue);

  const options = [
    "All Certificates",
    "Valid Certificates",
    "Invalid Certificates",
  ];

  const handleChange = (e) => {
    setSelectValue(e.target.value);
  };

  const [secondary, setSecondary] = useState(false);
  const [dense, setDense] = useState(false);
  const ListItemForHeader = [
    "Today",
    "Yesterday",
    "This Week",
    "Previous Week",
    "Last 30 Days",
  ];

  const handleClickOnRightButton = (e) => {
    setSelectValue(e.target.innerText);
    // console.log("doing null should run");
    handleClose();
    if (e.target.innerText === "Custom") popupState.open(anchorElD);
    switch (e.target.innerText) {
      case "Today":
        setData({
          startDate: moment().format("YYYY MM DD"),
          endDate: moment().format("YYYY MM DD"),
        });
        break;
      case "Yesterday":
        setData({
          startDate: moment().add(-1, "days").format("YYYY MM DD"),
          endDate: moment().add(-1, "days").format("YYYY MM DD"),
        });
        break;
      case "This Week":
        const today = moment();
        setData({
          startDate: today.startOf("week").format("YYYY MM DD"),
          endDate: today.endOf("week").format("YYYY MM DD"),
        });

        break;
      case "Previous Week":
        const day = moment().add(-7, "days");
        setData({
          startDate: day.startOf("week").format("YYYY MM DD"),
          endDate: day.endOf("week").format("YYYY MM DD"),
        });
        break;
      case "Last 30 Days":
        setData({
          startDate: moment().add(-30, "days").format("YYYY MM DD"),
          endDate: moment().format("YYYY MM DD"),
        });
        break;

      default:
        break;
    }
  };

  const [anchorEl, setAnchorEl] = useState(null);
  const [anchorElD, setAnchorElD] = useState(null);
  const popupState = usePopupState({
    variant: "popover",
    popupId: "demoPopover",
  });

  // const popupStateD = usePopupState({
  //   variant: "popover",
  //   popupId: "demoPopover",
  // });

  const handlePopOver = (event) => {
    setAnchorEl(event.currentTarget);
    setAnchorElD(event.currentTarget);
  };

  // const handlePopOverD = (event) => {
  //   console.log("running....");
  //   setAnchorElD(event.currentTarget);
  // };

  const handleClose = () => {
    // console.log("doing null");
    setAnchorEl(null);
  };

  const handleCloseD = () => {
    setAnchorElD(null);
    // console.log("close datepicker");
  };

  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;

  const openD = Boolean(anchorElD);
  const idD = openD ? "simple-popover" : undefined;
  // console.log(openD, anchorElD);

  return (
    <div style={{ margin: "20px 30px" }}>
      <Grid
        // container
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          borderColor: "grey.500",
        }}
      >
        <Grid md={3}>
          <div
            className="shareissuanceHeading"
            style={{
              fontSize: "23px",
              fontFamily: "Mulish",
              fontStyle: "normal",
              fontWeight: "600",
              color: "#585858",
            }}
          >
            All
          </div>

          {/* <Grid sx={{ fontSize: "1.4rem" }}>
            <MaterialSelect
              option_users={options}
              optionVal={tabValue}
              filterUsers={setTabValue}
            />
          </Grid> */}
        </Grid>

        <Grid
          spacing={1}
          sx={{
            display: "flex",
            flexDirection: "row-reverse",
            m: 1,
            mr: 5.2,
            justifyContent: "space-between",
            gap: "20px",
          }}
        >
          <Grid>
            <>
              {/* <ExportTable
              data={finalData.map((ele) => {
                return {
                  Date: moment(ele.createdAt.slice(0, -1)).format("DD/MM/yyyy"),
                  TransactionId: ele.id,
                  MembershipId: ele.toMemberId.memberId,
                  memberName:
                    ele.toMemberId.firstName + " " + ele.toMemberId.lastName,
                  FromMembershipId: ele.fromMemberId.memberId,
                  FrommemberName:
                    ele.fromMemberId.firstName +
                    " " +
                    ele.fromMemberId.lastName,
                  noOfShares: ele.noOfShares || "0",
                  shareType: ele.transactionId[0]?.typeOfShares,
                  amount:
                    ele?.transactionId[0]?.pricePerShare * ele.noOfShares ||
                    "0",
                  ValidCertNo: ele?.transactionId
                    .map((ele) => {
                      if (ele.isValid) {
                        return ele.shareCertificationNo;
                      }
                    })
                    .filter((e) => {
                      return e != undefined;
                    })
                    .join(","),
                  InValidCertNo: ele?.transactionId
                    .map((ele) => {
                      if (!ele.isValid) {
                        return ele.shareCertificationNo;
                      }
                    })
                    .filter((e) => {
                      return e != undefined;
                    })
                    .join(","),
                };
              })}
            /> */}
              <div
                className="exportBtn"
                onClick={() => {
                  exportFromJSON({
                    data: tableRef?.current?.state?.data?.map((ele) => {
                      return {
                        date: ele.createdAt,
                        _id: ele._id,
                        toMemberId: ele?.toMemberId?.memberId?.trim(),
                        toMemberType: ele?.toMemberId?.member?.trim(),
                        toMemberShareHolder: ele?.toMemberId?.shareholder?.trim(),
                        toFirstName: ele?.toMemberId?.firstName?.trim(),
                        toMiddleName: ele?.toMemberId?.middleName?.trim(),
                        toLastName: ele?.toMemberId?.lastName?.trim(),
                        toPhone: ele?.toMemberId?.phone?.trim(),
                        toEmail: ele?.toMemberId?.email?.trim(),
                        toAddressLine_1: ele?.toMemberId?.addressLine_1?.trim(),
                        toAddressLine_2: ele?.toMemberId?.addressLine_2?.trim(),
                        toState: ele?.toMemberId?.state?.trim(),
                        toDistrict: ele?.toMemberId?.district?.trim(),
                        toTaluka: ele?.toMemberId?.taluka?.trim(),
                        toCity: ele?.toMemberId?.city?.trim(),
                        toPincode: ele?.toMemberId?.pincode,
                        toOrganisationName: ele?.toMemberId?.organisation_name?.trim(),
                        toActivityStatus: ele?.toMemberId?.activityStatus,
                        toMobileSignUpStatus:
                          ele?.toMemberId?.mobileSignUpStatus,
                        toTotalShare: ele?.toMemberId?.totalShare,
                        toShareCapital: ele?.toMemberId?.shareCapital,
                        toShareApplicationMoney:
                          ele?.toMemberId?.shareApplicationMoney,

                        fromMemberId: ele?.fromMemberId?.memberId?.trim(),
                        fromMemberType: ele?.fromMemberId?.member?.trim(),
                        fromMemberShareHolder: ele?.fromMemberId?.shareholder?.trim(),
                        fromFirstName: ele?.fromMemberId?.firstName?.trim(),
                        fromMiddleName: ele?.fromMemberId?.middleName?.trim(),
                        fromLastName: ele?.fromMemberId?.lastName?.trim(),
                        fromPhone: ele?.fromMemberId?.phone,
                        fromEmail: ele?.fromMemberId?.email?.trim(),
                        fromAddressLine_1: ele?.fromMemberId?.addressLine_1?.trim(),
                        fromAddressLine_2: ele?.fromMemberId?.addressLine_2?.trim(),
                        fromState: ele?.fromMemberId?.state?.trim(),
                        fromDistrict: ele?.fromMemberId?.district?.trim(),
                        fromTaluka: ele?.fromMemberId?.taluka?.trim(),
                        fromCity: ele?.fromMemberId?.city?.trim(),
                        fromPincode: ele?.fromMemberId?.pincode,
                        fromOrganisationName:
                          ele?.fromMemberId?.organisation_name?.trim(),
                        fromActivityStatus: ele?.fromMemberId?.activityStatus,
                        fromMobileSignUpStatus:
                          ele?.fromMemberId?.mobileSignUpStatus,
                        fromTotalShare: ele?.fromMemberId?.totalShare,
                        fromShareCapital: ele?.fromMemberId?.shareCapital,
                        fromShareApplicationMoney:
                          ele?.fromMemberId?.shareApplicationMoney,

                        noOfShares: ele.noOfShares,
                        shareType: ele?.transactionId[0]?.typeOfShares,
                        amount:
                          parseInt(ele?.transactionId[0]?.pricePerShare) *
                            parseInt(ele?.noOfShares) || 0,
                        validCertificates: ele?.transactionId
                          .map((e) => {
                            if (e?.isValid) {
                              return e?.shareCertificationNo;
                            }
                          })
                          .filter((e) => {
                            return e != undefined;
                          })
                          .join(", "),
                        invalidCertificates: ele?.transactionId
                          .map((e) => {
                            if (!e.isValid) {
                              return e?.shareCertificationNo;
                            }
                          })
                          .filter((e) => {
                            return e != undefined;
                          })
                          .join(", "),
                        _id: ele._id,
                      };
                    }),
                    fileName,
                    exportType,
                  });
                }}
              >
                <i
                  className="fa fa-download"
                  style={{ color: "#ffffff", fontSize: "22px" }}
                ></i>
              </div>
            </>
          </Grid>

          <div
            style={{
              textTransform: "capitalize",
            }}
          >
            <button
              aria-describedby={id}
              className="btnHover"
              onClick={handlePopOver}
              style={{
                outline: "none",
                border: "none",
                fontSize: "20px",
                background: "#0096FF",
                borderRadius: "5px",
                color: "#FFFFFF",
                padding: "5px 15px",
                textTransform: "capitalize",
              }}
            >
              {selectValue}
              <i
                className={open ? "fa fa-caret-up" : "fa fa-caret-down"}
                style={{ marginLeft: 10 }}
              />
            </button>
            <Popover
              id={id}
              open={open}
              anchorEl={anchorEl}
              onClose={handleClose}
              anchorOrigin={{
                vertical: "bottom",
                horizontal: "left",
              }}
            >
              <Typography sx={{ p: 2 }}>
                <List dense={dense}>
                  {ListItemForHeader.map((value) => {
                    return (
                      <ListItem key={value}>
                        <ListItemButton
                          onClick={handleClickOnRightButton}
                          sx={{
                            textTransform: "capitalize",
                          }}
                        >
                          <ListItemText
                            primary={value}
                            secondary={secondary ? "Secondary text" : null}
                          />
                        </ListItemButton>
                      </ListItem>
                    );
                  })}
                  <ListItem>
                    {/* <PopupState variant="popover" popupId="demo-popup-popover"> */}
                    {/* {(popupState) => ( */}
                    {/* <div> */}
                    <ListItemButton
                      onClick={handleClickOnRightButton}
                      // {...bindTrigger(popupState)}
                      sx={{
                        textTransform: "capitalize",
                      }}
                    >
                      <ListItemText
                        primary={"Custom"}
                        // onClick={handleClickOnRightButton}
                        secondary={secondary ? "Secondary text" : null}
                      />
                    </ListItemButton>
                    {/* </div> */}
                    {/* )} */}
                    {/* </PopupState> */}
                  </ListItem>
                </List>
              </Typography>
            </Popover>
            <Popover
              id={idD}
              open={openD}
              anchorEl={anchorElD}
              onClose={handleCloseD}
              {...bindPopover(popupState)}
              anchorOrigin={{
                vertical: "center",
                horizontal: "left",
              }}
              transformOrigin={{
                vertical: "top",
                horizontal: "right",
              }}
            >
              <Typography
                sx={{ p: 2 }}
                style={{
                  // height: "85vh",
                  width: "46.5vw",
                  // minHeight: "20vh",
                }}
              >
                {/* <GeneralDateRangePicker
                  setData={setData}
                  handleCloseD={popupState.close}
                /> */}
                <GeneralDateRangePickerForReport
                  setData={setData}
                  handleCloseD={popupState.close}
                  setFilterDate={setFilterDate}
                  filterDate={filterDate}
                />
              </Typography>
            </Popover>
          </div>
        </Grid>
      </Grid>
    </div>
  );
};
